import { shortenAddress } from '../lib/formatters.js';
import type { RelayTransferResponse } from '../lib/api.js';

export interface ReceiptProps {
  readonly transfer: RelayTransferResponse;
  readonly explorerBaseUrl?: string;
  readonly onReset: () => void;
}

export function Receipt({ transfer, explorerBaseUrl, onReset }: ReceiptProps) {
  const explorerUrl = explorerBaseUrl
    ? `${explorerBaseUrl.replace(/\/$/, '')}/tx/${transfer.broadcast.hash}`
    : null;
  return (
    <div className="cp-card" aria-label="receipt-card">
      <h1>Tamam, gönderildi.</h1>
      <p className="cp-subtitle">İşlem zincire iletildi; onaylar geldikçe firma bilgilendirilecek.</p>
      <div className="cp-row" style={{ marginTop: 16 }}>
        <span style={{ color: 'var(--muted)' }}>Tutar</span>
        <span className="cp-mono cp-receipt-amount">
          {transfer.amountFormatted} {transfer.token.symbol}
        </span>
      </div>
      <div className="cp-row" style={{ marginTop: 12 }}>
        <span style={{ color: 'var(--muted)' }}>Hedef</span>
        <span className="cp-mono">{shortenAddress(transfer.recipient)}</span>
      </div>
      <div className="cp-row" style={{ marginTop: 12 }}>
        <span style={{ color: 'var(--muted)' }}>Tx Hash</span>
        {explorerUrl ? (
          <a href={explorerUrl} target="_blank" rel="noreferrer" className="cp-mono">
            {shortenAddress(transfer.broadcast.hash, 8, 6)}
          </a>
        ) : (
          <span className="cp-mono">{shortenAddress(transfer.broadcast.hash, 8, 6)}</span>
        )}
      </div>
      <button
        type="button"
        className="cp-button cp-secondary"
        onClick={onReset}
        style={{ marginTop: 16 }}
      >
        Yeni bir işlem
      </button>
    </div>
  );
}
